export const setItems = (state, payload) => {
    state.items = payload;
};

export const setPagination = (state, payload) => {
    state.pagination = payload;
};